import $ from 'cash-dom'
import { cart } from './cart'
import {
  hasCarDevice,
  hasCarFragrance,
  hasCarFragranceSub,
  hasCarSet,
  hasHomeDevice,
  hasHomeFragrance,
  hasHomeFragranceSub,
  hasHomeSet,
} from './cart-toolkit'
import {
  addItemsToCart,
  addVariantToCart,
  updateCart,
} from '../resources/shopify-cart'
import { getSellingPlanData } from '../resources/shopify-products'

// Panels
const cartBump = $('[data-element="cart-bump"]')
const panelHeadline = $('[data-element="cart-bump-headline"]')
const panelButton = $('[data-element="cart-bump-button"]')

const hideCartBump = () => {
  cartBump.addClass('hidden')
}

const showCartBump = () => {
  cartBump.removeClass('hidden')
}

const renderFragrancePanel = () => {
  panelButton
    .text(Pura.cart.bump.car_fragrance_cta)
    .attr(
      'onclick',
      `window.location.href='${Pura.cart.bump.car_fragrance_link}'`
    )
    .removeAttr('data-action data-variant')
    .removeClass('button')
    .addClass('button-outline')

  panelHeadline
    .text(Pura.cart.bump.car_fragrance_txt)
    .removeClass('max-w-[300px]')
    .addClass('max-w-[200px] ')

  showCartBump()
}

const renderHomeFragrancePanel = () => {
  panelButton
    .text(Pura.cart.bump.home_fragrance_cta)
    .attr(
      'onclick',
      `window.location.href='${Pura.cart.bump.home_fragrance_link}'`
    )
    .removeAttr('data-action data-variant')
    .removeClass('button')
    .addClass('button-outline')

  panelHeadline
    .text(Pura.cart.bump.home_fragrance_txt)
    .removeClass('max-w-[300px]')
    .addClass('max-w-[200px] ')

  showCartBump()
}
const renderCarDevicePanel = () => {
  panelButton
    .text(Pura.cart.bump.car_device_cta)
    .attr('data-action', 'add-variant-to-cart')
    .attr('data-variant', Pura.cart.bump.car_device)
    .removeAttr('onclick')
    .removeClass('button')
    .addClass('button-outline')

  panelHeadline
    .text(Pura.cart.bump.car_device_txt)
    .removeClass('max-w-[300px]')
    .addClass('max-w-[200px] ')

  showCartBump()
}
const renderHomeDevicePanel = () => {
  panelButton
    .text(Pura.cart.bump.home_device_cta)
    .attr('data-action', 'add-variant-to-cart')
    .attr('data-variant', Pura.cart.bump.home_device)
    .removeAttr('onclick')
    .removeClass('button')
    .addClass('button-outline')

  panelHeadline
    .text(Pura.cart.bump.home_device_txt)
    .removeClass('max-w-[300px]')
    .addClass('max-w-[200px] ')

  showCartBump()
}

const renderSubscriptionPanel = (data) => {
  let hasOTP = false
  let savings = 0
  const message = `<span class="fs-17 fw-6" data-element="bump-subtotal-savings"></span>`

  data.items.forEach((item) => {
    if (
      item.product_type === 'Fragrance' ||
      item.product_type === 'Car Fragrance'
    ) {
      if (
        item.selling_plan_allocation == null &&
        item.properties?._pura_group_role !== 'child' &&
        item.properties?._pura_has_no_subscription !== 'true' &&
        item.properties?._pura_cart_is_discounted !== 'true'
      ) {
        hasOTP = true
        savings += (item.final_line_price / 100) * 0.2
      }
    }
  })

  savings = savings.toFixed(2)

  if (Pura.cart.savings === '20%') {
    savings = Pura.cart.savings
  }

  panelHeadline
    .removeClass('max-w-[200px]')
    .html(Pura.cart.subscribe_text.replace('$', message))

  panelButton
    .text('Subscribe & Save')
    .attr('data-action', 'subscribe-form')
    .removeAttr('onclick data-variant')
    .removeClass('button-outline')
    .addClass('button')

  if (savings === 0 || !hasOTP) {
    hideCartBump()
  } else {
    savings = Pura.currency.format.replace('{{amount}}', savings)
    $('[data-element="bump-subtotal-savings"]').html(savings)
    showCartBump()
  }
}

const updateCartBump = (data) => {
  if (!Pura.cart.subscribe_save_enabled) {
    cartBump.addClass('hidden')
    return
  }

  hideCartBump()
  const carDevice = hasCarDevice(data)
  const homeDevice = hasHomeDevice(data)

  const carFragrance = hasCarFragrance(data)
  const carFragranceSub = hasCarFragranceSub(data)

  const homeFragrance = hasHomeFragrance(data)
  const homeFragranceSub = hasHomeFragranceSub(data)

  const carSet = hasCarSet(data)
  const homeSet = hasHomeSet(data)
  if (
    Pura.cart.bump.car_fragrance_enabled &&
    (carDevice || carSet) &&
    !carFragranceSub
  ) {
    renderFragrancePanel()
  } else if (
    Pura.cart.bump.car_device_enabled &&
    !carDevice &&
    !carSet &&
    (carFragranceSub || carFragrance)
  ) {
    renderCarDevicePanel()
  } else if (
    Pura.cart.bump.home_device_enabled &&
    !homeDevice &&
    !homeSet &&
    (homeFragranceSub || homeFragrance)
  ) {
    renderHomeDevicePanel()
  } else if (
    Pura.cart.bump.home_fragrance_enabled &&
    (homeDevice || homeSet) &&
    !homeFragranceSub
  ) {
    renderHomeFragrancePanel()
  } else if (homeFragrance || carFragrance) {
    renderSubscriptionPanel(data)
  }
}

const removeProductsFromCart = async (items) => {
  try {
    await updateCart(items)
  } catch (err) {
    console.error('Error removing items from cart:', err)
  }
}

const switchProducts = async (itemsToAdd, itemsToRemove) => {
  try {
    await removeProductsFromCart(itemsToRemove)
    await addItemsToCart(itemsToAdd)
    cart.updateAndShow()
  } catch (err) {
    console.error('Error switching products in cart:', err)
  }
}

const swapToSubscription = async () => {
  try {
    const productData = await getSellingPlanData()
    const itemsToAdd = { items: [] }
    const itemsToRemove = { updates: {} }

    const products = productData.filter((product) => {
      const groupIdExists = product.properties.some(
        ([key, value]) => key === '_pura_group_id' && value
      )
      const isValidType =
        !product.isSubscription &&
        (product.type === 'Fragrance' || product.type === 'Car Fragrance')

      return !groupIdExists && isValidType
    })
    if (products) {
      products.forEach((product) => {
        const { key, quantity, id, variantId, sellingPlans, properties = [] } = product
        const fullPriceKey = '_pura_full_price'
        const updatedProperties = { _pura_full_price_currency: 'USD' }

        properties.forEach(([key, value]) => {
          if (key === fullPriceKey) {
            updatedProperties[fullPriceKey] = value
          }
        })

        itemsToAdd.items.push({
          quantity,
          product_id: id,
          id: variantId,
          selling_plan: sellingPlans.id,
          properties: updatedProperties,
        })
        itemsToRemove.updates[key] = 0
      })
    }

    if (itemsToAdd.items.length) {
      switchProducts(itemsToAdd, itemsToRemove)
    }
  } catch (error) {
    console.error('Error fetching selling plan data:', error)
  }
}

panelButton.on('click', () => {
  const type = panelButton.attr('data-action')
  const originalState = panelButton.text()

  panelButton.html(`<svg
      class="h-6 w-6 animate-spin text-white"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64">
      <path
        d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"></path>
      <path
        d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-default"></path>
    </svg>`)

  if (type === 'subscribe-form') {
    swapToSubscription()
  } else if (type === 'add-variant-to-cart') {
    const variantId = panelButton.attr('data-variant')
    const properties = {}
    const sellingPlan = ''

    addVariantToCart(variantId, sellingPlan, 1, properties).then(() => {
      panelButton.text(originalState)
      cart.updateAndShow()
    })
  }
})

export { updateCartBump }
